<template>
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.6 3.33a6.5 6.5 0 0 1 1.4-.16c4.67 0 7.33 5.33 7.33 5.33a13.4 13.4 0 0 1-1.44 2.13m-2.54 1.27A6.4 6.4 0 0 1 8 13.17c-4.67 0-7.33-5.34-7.33-5.34a13.1 13.1 0 0 1 3.37-3.96l7.92 7.92Z"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.41 9.91a2 2 0 1 1-2.83-2.83M.67 1.17l14.66 14.66"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
